<template>
  <div>
    <div class="content-wrapper mb-3">
      <section class="content-header">
        <div
          class="overflow-hidden"
          style="border-bottom: 1px solid #00000017; height: 65px !important"
        >
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1>Drip Manager</h1>
              <ol class="breadcrumb float-sm-left">
                <router-link
                  tag="li"
                  class="breadcrumb-item"
                  :to="{ name: 'Home' }"
                  >Home</router-link
                >
                <router-link
                  tag="li"
                  class="breadcrumb-item"
                  :to="{ name: 'Dashboard' }"
                  >Dashboard</router-link
                >
                <li class="breadcrumb-item active">Drip Manager</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <div class="container">
        <!-- <div class="row">
          <div class="col-12"> -->
        <!-- <v-autocomplete
              v-model="type"
              :items="['All', 'Instant', 'Copied']"
              outlined
              dense
              class="v-input"
            ></v-autocomplete> -->
        <!-- <div class="d-flex flex-row" style="width: 40%; height: 38px"> -->
        <v-card>
          <v-card-title class="table-card-header--color height-100 pl-0 pb-0">
            <div class="d-flex height-34 mb-3">
              <v-select
                v-model="selectedStatus"
                :disabled="loading || fileLoading"
                :loading="loading || fileLoading"
                :items="['Inactive', 'Active']"
                solo
                dense
                label="Select recurring status"
                class="table-search-field--width-150 ml-2"
                height="20px"
              ></v-select>
              <v-autocomplete
                v-model="selectedDomains"
                :disabled="loading || fileLoading"
                :loading="loading || fileLoading"
                :items="domains"
                item-value="id"
                item-text="url"
                solo
                dense
                auto-select-first
                label="Select Domain(s)"
                class="v-input table-search-field--width-220"
              >
              </v-autocomplete>
              <v-select
                v-model="selectedType"
                :disabled="loading || fileLoading"
                :items="['Recurring', 'Welcome']"
                :loading="loading || fileLoading"
                solo
                dense
                height="20px"
                label="Select type"
                class="v-input table-search-field--width-220 ml-10"
              >
              </v-select>
              <v-btn
                :loading="fileLoading"
                :disabled="fileLoading"
                color="primary"
                class="ml-3 white--text position-absolute"
                style="right: 70px"
                fab
                small
                @click="
                  warning = true;
                  downloadList(10000, 0);
                "
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon dark v-bind="attrs" v-on="on">
                      mdi-download
                    </v-icon>
                  </template>
                  <span
                    >Download the file according to the table settings.</span
                  >
                </v-tooltip>
              </v-btn>
              <v-btn
                :loading="fileLoading"
                :disabled="fileLoading"
                color="primary"
                class="ml-3 white--text position-absolute"
                style="right: 21px"
                fab
                small
                @click="
                  warning = true;
                  downloadList(10000, 0, true);
                "
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon dark v-bind="attrs" v-on="on">
                      mdi-download-multiple
                    </v-icon>
                  </template>
                  <span>Download all drips.</span>
                </v-tooltip>
              </v-btn>
            </div>
            <div class="d-flex w-100 ml-2 mt-2">
              <!-- <small>SELECTED DRIPS: {{ selected.length }}</small> -->
            </div>
          </v-card-title>
          <!-- Data Table -->
          <v-data-table
            v-model="selected"
            :headers="headers"
            :loading="loading || fileLoading"
            :disable-filtering="loading || fileLoading"
            :disable-sort="loading || fileLoading"
            :disable-pagination="loading || fileLoading"
            :items="messages"
            :options.sync="options"
            :server-items-length="totalLength"
            loading-text="Loading Recurring Notifications ..."
            :footer-props="{
              'items-per-page-options': [10, 25, 50],
            }"
            single-expand
            :expanded.sync="expanded"
            :show-expand="!fileLoading"
            class="elevation-1 border"
          >
            <!-- Expanded Item -->
            <template v-slot:expanded-item="{ headers, item }">
              <td
                :colspan="headers.length"
                v-if="!fileLoading && item.type === 'recurring'"
              >
                <EditRecurring
                  @showSnackbar="showSnackbar"
                  :domain_id="item.domain_id"
                  :id="item.id"
                />
              </td>
              <td
                :colspan="headers.length"
                v-if="!fileLoading && item.type === 'welcome'"
              >
                <EditDrip
                  @showSnackbar="showSnackbar"
                  :domainId="item.domain_id"
                  :id="item.id"
                />
              </td>
            </template>
            <!-- Status -->
            <template v-slot:[`item.status`]="{ item }">
              <td class="text-left border-right">
                <div class="d-flex align-items-center">
                  <span
                    class="inActiveStatusSign mr-1 border-left"
                    :class="{ activeStatusSign: item.is_active }"
                  >
                  </span>
                  <span
                    class="inActiveStatus"
                    :class="{ activeStatus: item.is_active }"
                  >
                    {{ item.is_active ? "Active" : "Inactive" }}
                  </span>
                </div>
              </td>
            </template>
            <!-- Actions Buttons -->
            <template v-slot:[`item.actions`]="{ item }">
              <div
                class="d-flex flex-row justify-content-center w-100"
                style="height: 27px"
              >
                <!-- <button
                    class="btn btn-success act-btn-recur mr-2"
                    style="width: fit-content; color: #fff !important"
                    @click="id === item.id ? (id = '') : (id = item.id)"
                  >
                    Edit
                  </button> -->
                <!-- <button
                    class="btn btn-warning mr-3 act-btn-recur d-flex align-items-center"
                    style="width: fit-content; font-size: 11px"
                    @click="deactivate(id)"
                  >
                    Deactivate
                  </button> -->
                <v-btn
                  class="d-flex align-items-center"
                  :loading="loading || fileLoading"
                  @click="
                    showQuestion = true;
                    group_id = item.group_id;
                    id = item.id;
                  "
                  dark
                  small
                  color="error"
                >
                  <v-icon dark small> mdi-trash-can-outline </v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card>

        <!-- Question -->
        <Question
          v-if="showQuestion"
          @didClose="showQuestion = false"
          @confirmed="deleteRecurring(group_id, id)"
          @notConfirmed="showQuestion = false"
          title="Are you sure?"
          confirmButtonText="Delete"
          cancelButtonText="Cancel"
          isConfirmedTitle="Deleted!"
          dismissTitle="Canceled!"
          confirmButtonClasses="btn btn-success"
          cancelButtonClasses="btn btn-success"
          successIcon="success"
          errorIcon="success"
        />
        <!-- Error Snackbar -->
        <Error
          v-if="errorRecurringDrip || errorWelcomeDrip"
          :error="errorRecurringDrip || errorWelcomeDrip"
        />
        <div
          class="spinner-border text-primary position-fixed"
          style="left: 55%; top: 50%"
          v-if="spinner"
          role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
        <!-- </div> -->
        <!-- </div> -->
        <transition
          class="animate__faster"
          enter-active-class="animate__animated animate__fadeIn animate__faster"
          leave-active-class="animate__animated animate__fadeOut animate__faster"
        >
          <FailureSnackbar
            v-if="failure"
            @update-failure="handleUpdateToFailureSnackbar"
            :message="failureText"
          />
        </transition>
        <transition
          class="animate__faster"
          enter-active-class="animate__animated animate__fadeIn animate__faster"
          leave-active-class="animate__animated animate__fadeOut animate__faster"
        >
          <SuccessSnackbar
            v-if="success"
            @update-success="handleUpdateToSuccessSnackbar"
            message="Successfully!"
          />
        </transition>
        <v-snackbar v-model="warning" :timeout="-1" top color="primary" text>
          It can take up to <b>15 minutes</b>.
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="warning = false"> Close </v-btn>
          </template>
        </v-snackbar>
      </div>
    </div>
  </div>
</template>

<script>
import EditDrip from "../popUps/drip/welcome/EditDrip.vue";
import EditRecurring from "../popUps/drip/recurring/EditRecurring.vue";
import Question from "../popUps/Question.vue";
import SuccessSnackbar from "../popUps/SuccessSnackbar.vue";
import FailureSnackbar from "../popUps/FailureSnackbar.vue";
import Error from "../popUps/Error.vue";
import { BSpinner } from "bootstrap-vue";
import Drip from "../../apis/Drip";

import { mapState, mapActions } from "vuex";
import common from "../../mixins/common";

import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";

export default {
  name: "DripManager",
  mixins: [common],
  components: {
    Error,
    Question,
    EditDrip,
    EditRecurring,
    BSpinner,
    SuccessSnackbar,
    FailureSnackbar,
  },
  data() {
    return {
      expanded: [],
      singleExpand: false,

      group_id: null,
      id: null,

      success: false,
      showQuestion: false,
      showEditBlock: false,
      selectedDomains: [],
      selectedStatus: "Active",
      selectedType: "Recurring",
      spinner: false,

      options: {},
      itemsPerPage: 10,
      totalLength: null,
      page: 1,

      fileLoading: false,
      failure: false,
      failureText: "",

      search: "",
      success: false,
      warning: false,
      loading: true,
      items: [],
      headers: [
        {
          text: "Domain Id",
          align: "center",
          sortable: false,
          value: "domain_id",
          divider: true,
          class: "table-header--color border-left",
          cellClass: "border-left",
        },
        {
          text: "Message Id",
          align: "center",
          sortable: false,
          value: "id",
          divider: true,
          class: "table-header--color border-left",
          cellClass: "border-left",
        },
        {
          text: "Title",
          align: "left",
          sortable: false,
          value: "title",
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Created at",
          align: "center",
          sortable: false,
          value: "created_at",
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Type",
          align: "center",
          sortable: false,
          value: "meta.type",
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Status",
          value: "status",
          align: "center",
          sortable: false,
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "actions",
          divider: true,
          class: "table-header--color",
        },
      ],

      selected: [],
      date_start: null,
      date_end: null,

      recurringList: [],
      messagesToExport: [],
    };
  },
  computed: {
    ...mapState({
      recurringDrips: (state) => state.recurringDrip.recurringDrips,
      drips: (state) => state.welcomeDrip.drips,
      domains: (state) => state.domain.domains,
      drips: (state) => state.welcomeDrip.drips,
      errorRecurringDrip: (state) => state.recurringDrip.errorRecurringDrip,
      errorWelcomeDrip: (state) => state.welcomeDrip.errorWelcomeDrip,
    }),
    recurringDrips: {
      get: function () {
        return this.$store.state.recurringDrip.recurringDrips;
      },
      set: function (newValue) {
        return newValue;
      },
    },

    messages() {
      if (this.selectedType === "Recurring") {
        return this.recurringDrips;
      } else if (this.selectedType === "Welcome") {
        return this.drips;
      }
    },
    // copiedRecurrings() {
    //   return this.recurringDrips.filter(
    //     (el) =>
    //       el.meta !== null &&
    //       el.meta.type !== undefined &&
    //       el.meta.type === "copied"
    //   );
    // },
    // instantRecurrings() {
    //   return this.recurringDrips.filter(
    //     (el) =>
    //       el.meta !== null &&
    //       el.meta.type !== undefined &&
    //       el.meta.type === "instant"
    //   );
    // },
  },
  mounted() {
    this.show().then(() => {
      this.selectedDomains = this.domains.length ? this.domains[0].id : [];
    });

    this.options = {
      itemsPerPage: this.itemsPerPage,
      page: this.page,
    };
  },
  methods: {
    ...mapActions([
      "show",
      "resetRecurringDrips",
      "getRecurringDrips",
      "getDrips",
      "deleteRecurringDripArray",
      "deleteRecurringDrip",
      "deleteDripArray",
    ]),

    obtainMessages() {
      if (this.selectedType === "Recurring") {
        this.obtainRecurringDrips();
      } else if (this.selectedType === "Welcome") {
        this.obtainWelcomeDrips();
      }
    },
    downloadList(length, page, multiple = false) {
      let activeness = this.selectedStatus ? 1 : 0;
      let domainIdParams = multiple
        ? ""
        : `&where[domain_id]=${this.selectedDomains}`;
      let scheduleParams =
        this.selectedType === "Recurring"
          ? `&with[schedules.audiences]=name&castRelationsToString[schedules][audiences]=name`
          : "&with[schedules]=after_days,after_hours,after_mins";

      this.fileLoading = true;
      document.body.style.cursor = "wait";

      return new Promise((resolve, reject) => {
        Drip.get(
          this.selectedType.toLowerCase(),
          `?order_by=id:desc&paginate=true&pageLength=${length}&page=${page}&where[type]=${this.selectedType.toLowerCase()}&select=id,domain_id,is_active,type,title,body,url,icon,created_at,updated_at&where[is_active]=${activeness}` +
            domainIdParams +
            scheduleParams
        )
          .then((response) => {
            resolve(response);

            return response.data.data.data;
          })
          .then((messages) => {
            this.messagesToExport.push(messages);

            if (messages.length < length) {
              this.messagesToExport = this.messagesToExport.flat(2);
              this.createCSVFile(this.messagesToExport);

              queueMicrotask(() => {
                this.warning = false;
                this.fileLoading = false;
                document.body.style.cursor = "default";
              });

              return false;
            }

            this.downloadList(length, ++page, multiple);
          })
          .catch((error) => {
            reject(error);

            this.failure = error;
            this.failureText = error;
          });
      });
    },
    createCSVFile(messages) {
      if (messages.length) {
        let js = messages;
        let ws = XLSX.utils.json_to_sheet(js);

        let wb = {
          Sheets: {
            List: ws,
          },
          SheetNames: ["List"],
        };
        let excelBuffer = XLSX.write(wb, {
          bookType: "csv",
          type: "array",
        });
        let data = new Blob([excelBuffer], {
          type: "text/csv",
        });

        saveAs(data, `messages_list`);

        this.messagesToExport = [];
      } else {
        this.failureText = "No data to download!";
        this.failure = true;
      }
    },
    deleteRecurring(group_id, id) {
      if (this.selected.length > 1) {
        let arrOfIds = this.selected.map(function (item) {
          return item["id"];
        });

        arrOfIds = arrOfIds.toString().replace(/[\[\]']+/g, "");

        this.deleteRecurringDripArray({
          domainId: this.selectedDomains,
          ids: arrOfIds,
        }).then(() => {
          if (!this.items.length) {
            this.obtainRecurringDrips({
              page: this.page - 1,
              itemsPerPage: this.itemsPerPage,
            });
          }
          this.totalLength -= this.selected.length;
          this.selected = [];
        });
      } else {
        this.deleteRecurringDrip([group_id, id]).then(() => {
          if (!this.recurringDrips.length) {
            this.obtainRecurringDrips({
              page: this.page - 1,
              itemsPerPage: this.itemsPerPage,
            });
          }
          this.totalLength -= 1;
          this.selected = [];
        });
      }

      this.shwQuestion = false;
    },
    requestToObtainMessages(page) {
      this.spinner = true;

      let domainIdParams = this.selectedDomains
        ? `&where[domain_id]=${this.selectedDomains.toString()}`
        : "";
      let statusParams =
        this.selectedStatus !== 0 && !!this.selectedStatus
          ? `&where[is_active]=${this.selectedStatus === "Active" ? 1 : 0}`
          : "";

      return new Promise((resolve, reject) => {
        Drip.get(
          "recurring",
          `?with[schedules]=*&order_by=created_at:desc&limit=1000&paginate=true&pageLength=1000&page=${page}` +
            statusParams +
            domainIdParams
        )
          .then((response) => {
            resolve(response);

            for (let recurring of response.data.data.data) {
              this.selected.push(recurring);
            }

            if (response.data.data.data.length === 1000) {
              this.requestToObtainMessages(page + 1);
            }

            if (!response.data.data.data.length < 1000) {
              this.spinner = false;
            }
          })
          .catch((error) => {
            reject(error);
            this.spinner = false;
          });
      });
    },
    selectAll() {
      this.loading = true;

      if (this.selected.length < this.totalLength) {
        this.requestToObtainMessages(1);
      } else if (this.selected.length === this.totalLength) {
        this.spinner = false;
        this.selected = [];
      }

      this.loading = false;
    },
    obtainRecurringDrips() {
      return new Promise((resolve) => {
        const { page, itemsPerPage } = this.options;
        let domainIdParams = this.selectedDomains
          ? `&where[domain_id]=${this.selectedDomains.toString()}`
          : "";
        let statusParams =
          this.selectedStatus !== 0 && !!this.selectedStatus
            ? `&where[is_active]=${this.selectedStatus === "Active" ? 1 : 0}`
            : "";

        this.getRecurringDrips({
          params:
            `?with[schedules]=*&order_by=created_at:desc&limit=1000&paginate=true&pageLength=${itemsPerPage}&page=${page}` +
            statusParams +
            domainIdParams,
        }).then((response) => {
          resolve(response);

          this.totalLength = response.data.data.total;
          this.itemsPerPage = itemsPerPage;
          this.page = page;
        });
      });
    },
    obtainWelcomeDrips() {
      return new Promise((resolve) => {
        const { page, itemsPerPage } = this.options;
        let domainIdParams = this.selectedDomains
          ? `&where[domain_id]=${this.selectedDomains.toString()}`
          : "";
        let statusParams =
          this.selectedStatus !== 0 && !!this.selectedStatus
            ? `&where[is_active]=${this.selectedStatus === "Active" ? 1 : 0}`
            : "";

        this.getDrips(
          `?with[schedules]=*&order_by=created_at:desc&limit=1000&paginate=true&pageLength=${itemsPerPage}&page=${page}` +
            statusParams +
            domainIdParams
        ).then((response) => {
          resolve(response);

          this.totalLength = response.data.data.total;
          this.itemsPerPage = itemsPerPage;
          this.page = page;
        });
      });
    },
    showSnackbar(val) {
      this.success = val;
    },
  },
  watch: {
    "$route.name": {
      handler: "resetRecurringDrips",
      deep: true,
      immediate: true,
    },
    options: {
      handler() {
        this.loading = true;

        this.obtainMessages();

        queueMicrotask(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
      },
      deep: true,
    },
    selectedType: {
      handler() {
        this.loading = true;

        this.options = {
          itemsPerPage: 10,
          page: 1,
        };

        this.obtainMessages();

        queueMicrotask(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
      },
      deep: true,
      immediate: true,
    },
    selectedDomains: {
      handler() {
        this.loading = true;

        this.selected = [];

        this.obtainMessages();

        queueMicrotask(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
      },
      deep: true,
      immediate: true,
    },
    selectedStatus: {
      handler() {
        this.loading = true;

        this.selected = [];

        this.obtainMessages();

        queueMicrotask(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
      },
      deep: true,
      immediate: true,
    },
    // type(newType) {
    //   switch (newType) {
    //     case "Copied":
    //       this.recurringDrips = this.copiedRecurrings;
    //       break;
    //     case "Instant":
    //       this.recurringDrips = this.instantRecurrings;
    //       break;
    //     case "All":
    //       this.recurringDrips = this.recurringDrips;
    //       break;
    //     default:
    //       break;
    //   }
    // },
  },
};
</script>

<style scoped>
.v-input {
  width: 20% !important;
}
.inActiveStatusSign {
  /* Rectangle 189 */
  /* position: absolute; */
  width: 10px;
  height: 10px;
  left: 8px;
  top: 15px;

  /* Red */
  background: #e45b54;
  border-radius: 1px;
}

.activeStatusSign {
  /* Rectangle 189 */
  /* position: absolute; */
  width: 10px;
  height: 10px;
  left: 8px;
  top: 15px;

  /* Green */
  background: #52a451 !important;
  border-radius: 1px;
}
.v-select__selections {
  height: 36px;
}
</style>
